import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { SyndicationChannel, SyndicationChannelListComponent } from '@rma/dashboard/reporting/public/ui-syndication-channels';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-my-subscription-review-channels-card',
  imports: [RmaIconComponent, SyndicationChannelListComponent, TranslocoModule],
  templateUrl: './my-subscription-review-channels-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('subscriptions')],
})
export class MySubscriptionReviewChannelsCardComponent implements OnChanges {
  @Input()
  public displayPlatforms: SyndicationChannel[] = [];

  @Input()
  public hasRmaReviews: boolean | null = null;

  @HostBinding()
  public readonly class = 'block';

  protected platformCount = 0;
  protected channels: SyndicationChannel[] = [];

  public ngOnChanges(): void {
    const hasRma: SyndicationChannel[] = this.hasRmaReviews ? ['rma'] : [];
    this.channels = [...this.displayPlatforms, ...hasRma];
    this.platformCount = (this.displayPlatforms?.length ?? 0) + (this.hasRmaReviews ? 1 : 0);
  }
}
